// ========================================
// API base URL
// ========================================
// Priority:
// 1. USE_LOCAL_BACKEND = true   → local Node backend
// 2. REACT_APP_USE_STAGING=true → Railway staging (so .env can flip this without
//    fighting REACT_APP_API_URL — set USE_STAGING=false to respect API_URL for prod)
// 3. REACT_APP_API_URL            → optional explicit URL (CI / custom)
// 4. default                      → Railway production
//
// Staging: https://romantic-inspiration-staging.up.railway.app
// Production: https://romantic-inspiration-production.up.railway.app
// ========================================

// Set to true in this file for local backend development
const USE_LOCAL_BACKEND = false;

const LOCAL_BACKEND_URL = 'http://localhost:3010';
const RAILWAY_STAGING_URL = 'https://romantic-inspiration-staging.up.railway.app';
const RAILWAY_PRODUCTION_URL = 'https://romantic-inspiration-production.up.railway.app';

/** Ensure absolute URL — env vars like `beta-back-production.up.railway.app` are otherwise treated as relative paths. */
const normalizeApiUrl = (url: string): string => {
  const trimmed = url.trim().replace(/\/+$/, '');
  if (!trimmed) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

const explicitUrl = process.env.REACT_APP_API_URL?.trim();
const useStaging = process.env.REACT_APP_USE_STAGING === 'true';
const stagingFromEnv = normalizeApiUrl(
  process.env.REACT_APP_API_URL_STAGING?.trim() || RAILWAY_STAGING_URL
);

const resolvedUrl = USE_LOCAL_BACKEND
  ? LOCAL_BACKEND_URL
  : useStaging
    ? stagingFromEnv
    : normalizeApiUrl(explicitUrl || RAILWAY_PRODUCTION_URL);

export const API_URL = resolvedUrl;

export const API_BASE_URL = `${API_URL}/api`;

// CORS configuration
export const CORS_CONFIG = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  },
};
